import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { PresalesTask, CreatePresalesTask } from '../models/presales.model';

@Injectable({ providedIn: 'root' })
export class PresalesTaskService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/PresalesTask`;

  /** Every task, project-linked and standalone — what the tracker board loads. */
  getAll(): Observable<PresalesTask[]> {
    return this.http.get<PresalesTask[]>(this.apiUrl).pipe(retry(2));
  }

  getByPresalesProjectId(presalesProjectId: string): Observable<PresalesTask[]> {
    return this.http
      .get<PresalesTask[]>(`${this.apiUrl}/presales-project/${presalesProjectId}`)
      .pipe(retry(2));
  }

  getById(id: string): Observable<PresalesTask> {
    return this.http.get<PresalesTask>(`${this.apiUrl}/${id}`).pipe(retry(2));
  }

  add(dto: CreatePresalesTask): Observable<PresalesTask> {
    return this.http.post<PresalesTask>(this.apiUrl, dto);
  }

  update(id: string, dto: CreatePresalesTask): Observable<PresalesTask> {
    return this.http.put<PresalesTask>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
